import { PlusIcon } from "@heroicons/react/20/solid";
import { orderBy } from "lodash";
import { useEffect } from "react";
import { connect } from "react-redux";
import { Actions } from "../../../store/actions/employeeActions";
import NoItemsRow from "../../common/NoItemsRow";
import ChildrenModal from "./AddChildModal";
import ChildLeaveModal from "./ChildLeaveModal";
import ChildRelatedLeave from "./ChildRelatedLeave";
import ChildrenRow from "./ChildRow";

const Children = ({ children, toggleChildrenModal, leave, childRelatedLeave, loading, getChildren }) => {
	useEffect(() => {
		getChildren();
	}, []);

	// if (loading) return <LoadingContent />;
	return (
		<div className="px-8">
			<ChildrenModal />
			<ChildLeaveModal />
			<div
				className="col-xs-12 form-section"
				style={{ marginTop: 30 }}
			>
				<div className="col-xs-6 section-header">
					<h1>Children</h1>
				</div>
				<div className="col-xs-6">
					<button
						className="btn btn-success pull-right"
						type="button"
						onClick={() => toggleChildrenModal()}
					>
						<PlusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
						<div style={{ float: "left" }}>Add Child</div>
					</button>
				</div>
				<div className="clearfix" />
				{children?.length > 0 ? (
					<div className="form-inner-section pr-0 pl-0">
						<div
							style={{
								display: "grid",
								gridGap: "1.5rem",
								grid: "1.5rem",
								gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
								padding: "1rem",
								borderBottom: "solid rgb(244,244,244) 4px",
							}}
						>
							<div style={{ gridColumn: "span 1 / span 4", textAlign: "center", opacity: "0.75" }}>
								<h5>Reference</h5>
							</div>
							<div style={{ gridColumn: "span 1 / span 4", textAlign: "center", opacity: "0.75" }}>
								<h5>Date of Birth</h5>
							</div>
							<div style={{ gridColumn: "span 1 / span 4", textAlign: "center", opacity: "0.75" }}>
								<h5>Age</h5>
							</div>
							<div style={{ gridColumn: "span 1 / span 4", textAlign: "center", opacity: "0.75" }}></div>
						</div>
						{children?.map((child, index) => {
							const isLast = index + 1 == children.length;
							return (
								<ChildrenRow
									child={child}
									isLast={isLast}
								/>
							);
						})}
					</div>
				) : (
					<table className="js-table-sections table table-hover">
						<NoItemsRow name={"Children"} />
					</table>
				)}
			</div>
			<div
				className="col-xs-12 form-section"
				style={{ marginTop: 30 }}
			>
				<div className="col-xs-6 section-header">
					<h1>Child Related Leave</h1>
				</div>
				<div className="clearfix" />
				{childRelatedLeave?.length > 0 ? (
					<div className="form-inner-section pr-0 pl-0">
						<div
							style={{
								display: "grid",
								gridGap: "1.5rem",
								grid: "1.5rem",
								gridTemplateColumns: "repeat(7, minmax(0, 1fr))",
								padding: "1rem",
								borderBottom: "solid rgb(244,244,244) 4px",
							}}
						>
							<div style={{ gridColumn: "span 1 / span 7", textAlign: "center", opacity: "0.75" }}>
								<h5>Child</h5>
							</div>
							<div style={{ gridColumn: "span 1 / span 7", textAlign: "center", opacity: "0.75" }}>
								<h5>Applied On</h5>
							</div>
							<div style={{ gridColumn: "span 1 / span 7", textAlign: "center", opacity: "0.75" }}>
								<h5>From</h5>
							</div>
							<div style={{ gridColumn: "span 1 / span 7", textAlign: "center", opacity: "0.75" }}>
								<h5>To</h5>
							</div>
							<div style={{ gridColumn: "span 1 / span 7", textAlign: "center", opacity: "0.75" }}>
								<h5>Type</h5>
							</div>
							<div style={{ gridColumn: "span 1 / span 7", textAlign: "center", opacity: "0.75" }}>
								<h5>Status</h5>
							</div>
							<div style={{ gridColumn: "span 1 / span 7", textAlign: "center", opacity: "0.75" }}></div>
						</div>
						{childRelatedLeave?.map((leave, index) => {
							const isLast = index + 1 == childRelatedLeave.length;
							return (
								<ChildRelatedLeave
									child={children?.find((item) => item?.id == leave?.childId)}
									leave={leave}
									isLast={isLast}
								/>
							);
						})}
					</div>
				) : (
					<table className="js-table-sections table table-hover">
						<NoItemsRow name={"Child Related Leave"} />
					</table>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	return {
		children: orderBy(
			state.employee?.children?.list || [],
			["deceased", "doesNotHaveCustody", "dateOfBirth", "expectedDate", "reference"],
			["asc", "asc", "asc", "asc", "asc"],
		),
		childRelatedLeave: state.employee?.children?.leave,
		loading: state.employee?.children?.loading,
		currency: state.company?.settings?.currency,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	toggleChildrenModal: () => dispatch(Actions.toggleChildrenModal({ open: true })),
	getChildren: () => dispatch(Actions.getChildren()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Children);
